import { useCallback, useEffect } from "react";
import { UserAddress, CreateUserAddress, UpdateUserAddress } from "../types/models/UserAddress.d";
import { UpdateEntityUserAddress } from "../types/models/UserAddress";
import { useGetUserAddressListQuery, useInsertUserAddressMutation, useDeleteUserAddressMutation, } from "../apis/UserAddress.api";
import { useDeleteDialog, useDescriptionAlert } from '../../share';
import { useNavigate } from "react-router";
import { t } from "@lingui/core/macro";

export default function useUserAddress(page: number, pageSize: number) {

    const navigate = useNavigate()
    const { openDialog, closeDialog } = useDeleteDialog();

    const { openSuccessAlert, openFailAlert } = useDescriptionAlert()

    const [insertUserAddressMutation, { 
        isLoading: insertUserAddressLoading, 
        isSuccess: insertUserAddressIsSuccess,
        isError: insertUserAddressIsError,
        error: insertUserAddressError,
    }] = useInsertUserAddressMutation()
    
    const [deleteUserAddressMutation, { 
        isLoading: deleteUserAddressLoading,
        isSuccess: deleteUserAddressIsSuccess,
        isError: deleteUserAddressIsError,
        error: deleteUserAddressError,
    }] = useDeleteUserAddressMutation()

    const loading =
        insertUserAddressLoading ||
        
        deleteUserAddressLoading ||
        false

    const insertUserAddress = useCallback(async (userAddress: CreateUserAddress, redirectPath: string|undefined) => {
        try {
            const data = await insertUserAddressMutation(userAddress).unwrap()
            if (data) {
                if (redirectPath) {
                    if (redirectPath !== '.') {
                        navigate(redirectPath, {relative: 'path'})
                    }
                } else {
                    navigate(`../${data.id}`, {relative: 'path'})
                }
                return data;
            }
        } catch (e) {
            console.log("add error", e)
            openFailAlert(t`Add error: ` + e.toString())
        }
    }, [insertUserAddressMutation, navigate])
    
    useEffect(() => {
        if (insertUserAddressIsSuccess) {
            openSuccessAlert('User Address created')
        } else if (insertUserAddressIsError) {
            console.log("add error", insertUserAddressError)
            openFailAlert(t`User Address add error: ` + insertUserAddressError?.data?.message)
        }
    }, [
        insertUserAddressIsSuccess,
        insertUserAddressIsError,
        insertUserAddressError
    ]);

    

    const deleteUserAddress = useCallback((userAddress: UserAddress, redirectPath: string|undefined) => {
        openDialog(async () => {
            userAddress = {
                ...userAddress,
            }
            try {
                const { data } = await deleteUserAddressMutation(userAddress);
                if (data != null) {
                    if (redirectPath) {
                        navigate(redirectPath, {relative: 'path'})
                    }
                }
            } catch (e) {
                console.log("delete error", e)
                openFailAlert(t`Delete error: ` + e.toString())
            }
            closeDialog()
        });
    }, [deleteUserAddressMutation, closeDialog, openDialog])
    
    useEffect(() => {
        if (deleteUserAddressIsSuccess) {
            openSuccessAlert(t`User Address deleted`)
        } else if (deleteUserAddressIsError) {
            console.log("delete error", deleteUserAddressError)
            openFailAlert(t`User Address delete error: ` + deleteUserAddressError?.data?.message)
        }
    }, [
        deleteUserAddressIsSuccess,
        deleteUserAddressIsError,
        deleteUserAddressError
    ]);

    return {
        loading,
        insertUserAddress,
        
        deleteUserAddress
    }
}
